import { BsUtil } from "../util";
import { setLibConfig } from "../config";
/**
 * Initialize BsUtil configuration. Create new instance or return already created one
 * @param {BsUtilInitConfig} config Initial configuration to be set
 * @return {BsUtil} Newly created or already existing  instance
 */
export const init = (config) => {
    setLibConfig(config);
    return BsUtil.getInstance();
};
//# sourceMappingURL=init.js.map